import { isAvailableLocale } from '../utils/locale'
import { safeLink } from '../utils/links'

type Maybe<T> = NonNullable<T> | undefined | null

export function mapNavigationLink(
  url?: Maybe<string>,
  page?: Maybe<{ slug?: Maybe<string>; locale: Maybe<string> }>
): string | undefined {
  if (url && !isValidPage(page)) return sanitizeSlug(url)
  if (!page || !isValidPage(page)) return '/'

  // For homepage en/ or fr/, when slug is missing
  const slug = page.slug ? sanitizeSlug(page.slug) : ''
  return `/${page.locale}${slug}`
}

function isValidPage(page?: Maybe<{ locale: Maybe<string> }>): boolean {
  return Boolean(page?.locale && isAvailableLocale(page.locale))
}

export function sanitizeSlug(slug: string): string {
  if (slug.startsWith('/')) {
    slug = slug.slice(1)
  }
  if (slug.endsWith('/')) {
    slug = slug.slice(0, -1)
  }
  // Encode URI components to handle special characters like 'é'
  slug = encodeURIComponent(slug)

  // Replace encoded slashes with a safe representation
  slug = slug.replace(/%2F/g, '/')
  // Replace encoded colons with a safe representation
  slug = slug.replace(/%3A/g, ':')
  // Replace encoded question marks with a safe representation
  slug = slug.replace(/%3F/g, '?')
  // Replace encoded ampersands with a safe representation
  slug = slug.replace(/%26/g, '&')
  // Replace encoded hashes with a safe representation
  slug = slug.replace(/%23/g, '#')
  // Replace encoded spaces with a safe representation
  slug = slug.replace(/%20/g, ' ')
  // Replace encoded plus signs with a safe representation
  slug = slug.replace(/%2B/g, '+')
  // Replace encoded equals signs with a safe representation
  slug = slug.replace(/%3D/g, '=')
  // Replace encoded commas with a safe representation
  slug = slug.replace(/%2C/g, ',')
  // Replace encoded periods with a safe representation
  slug = slug.replace(/%2E/g, '.')

  return safeLink(slug)
}
